import { type Error } from '@capsicum/common';

import { type CodeInputError, UserCredentialsDeniedReason } from '../models';

export const getCodeInputError = (error: Error): CodeInputError => {
	const errorReasonCode = error?.errors?.[0]?.meta?.reason?.[0]?.code;

	switch (errorReasonCode) {
		case UserCredentialsDeniedReason.NO_GRANT_NO_RULE:
			return 'disabled-account';
		case UserCredentialsDeniedReason.USER_LOCATION_DENIED:
			return 'disabled-region';
		default:
			return 'generic';
	}
};
